import React from "react";
import HomeSlider from "./home_slider/HomeSlider";
import InquiryBox from "../inquiry_box/InquaryBox";
import CompanySlider from "../AboutUs/CompanySlider";
import AboutUs from "./about_us/AboutUs";
import DigitalIndiaQuote from "./DigitalIndiaQuote/DigitalIndiaQuote";
import CourseCards from "./CourseCards/CourseCards";
import StatsCard from "./StatsCard/StatsCard";
import KeyFeatures from "./Key Features/KeyFeatures";

const HomePage = () => {
  return (
    <div>
      <HomeSlider />
      <InquiryBox />

      <AboutUs />
      <CompanySlider />

      <CourseCards />
      <StatsCard />

      <KeyFeatures />
      <DigitalIndiaQuote />
    </div>
  );
};

export default HomePage;
